/**
 * Scroll-related constants for consistent behavior across components
 */

export const SCROLL_THRESHOLD = 0.1;
export const HEADER_COMPACT_THRESHOLD = 50;
export const HEADER_SCROLL_OFFSET = 120;
